import { render, staticRenderFns } from "./dialogMenu.vue?vue&type=template&id=42428bc0&"
import script from "./dialogMenu.vue?vue&type=script&lang=js&"
export * from "./dialogMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports